module.exports = __webpack_public_path__ + "img/20200414.301b0957.jpg";